// extracted by mini-css-extract-plugin
export default {"slotWrapper":"styles_slotWrapper__ht-C9","visible":"styles_visible__4W-va","hidden":"styles_hidden__204KA","tutor":"styles_tutor__srbr1","pulse-scale":"styles_pulse-scale__nbCIT"};